var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 5.625H9.375C8.87772 5.625 8.40081 5.82254 8.04917 6.17417C7.69754 6.52581 7.5 7.00272 7.5 7.5V22.5C7.5 22.9973 7.69754 23.4742 8.04917 23.8258C8.40081 24.1775 8.87772 24.375 9.375 24.375H20.625C21.1223 24.375 21.5992 24.1775 21.9508 23.8258C22.3025 23.4742 22.5 22.9973 22.5 22.5V11.25L16.875 5.625Z",
    stroke: "#8F90A6",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 5.625V11.25H22.5",
    stroke: "#8F90A6",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6516 20.3033L12.3483 15M12.3483 20.3033L17.6516 15",
    stroke: "#8F90A6",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/No_Data.4fd3ee74bb1c72d941d6d4d59fbb7fd5.svg";
export { ForwardRef as ReactComponent };